import { ModeratorPermissionsResponse } from "../types/api/moderators";
import { UserRole, isAdminRole } from "../types/common/permissions";

/**
 * Стартовая страница по правам профиля.
 *
 * Возвращает null, когда идти некуда: вызывающий код показывает экран отказа.
 * Раньше в этом случае возвращался "/", то есть тот же маршрут, на котором стоит
 * RoleBasedRedirect, и страница не рендерилась вовсе (ALX-59538, ALX-59896).
 *
 * У admin и superadmin строки прав нет вообще, доступ им даётся по роли
 * (см. ProtectedRoute), поэтому для них есть отдельный фолбэк.
 */
export const getDefaultPage = (
  permissions?: Partial<ModeratorPermissionsResponse>,
  role?: UserRole
): string | null => {
  const pages = [
    { route: "/users", check: permissions?.canViewUsers },
    { route: "/ads", check: permissions?.canViewAds },
    { route: "/users/appeals", check: permissions?.canViewAppeals },
    { route: "/users/suggestions", check: permissions?.canViewProposals },
    { route: "/users/complaints", check: permissions?.canViewComplaints },
    { route: "/metrics", check: permissions?.canViewDashboardMetrics },
  ];

  const defaultPage = pages.find((page) => page.check);

  if (defaultPage) {
    return defaultPage.route;
  }

  return isAdminRole(role) ? "/users" : null;
};
